/**
 * CHOOSE YOUR PIECE: the numbered-piece selector on the PRODUCT PAGE of the three Spirit of the Nation watches.
 *
 * On those three pages ADD TO BAG does not add anything: it is intercepted and opens one bottom sheet. The customer chooses a piece
 * (01 to 55 = the product's real "Piece Number" variants) and only then is that exact variant added to the bag. Nothing is added
 * before the choice, and no default piece is ever added.
 *
 * SOURCE OF TRUTH. The product's real Shopify variants. Availability is read from the storefront product feed, /products/<handle>.js
 * (served uncached), when the sheet opens, every 20 s while it is open, when the tab becomes visible again, and once more immediately
 * before the add. Nothing is kept in localStorage, cookies, settings or any list: a number is "reserved" only because Shopify says
 * that variant is not available. The add is a normal cart request for that variant id; Shopify's inventory (1 per piece, policy DENY)
 * decides, so two people choosing the same number cannot both succeed whatever the browsers think.
 *
 * The script exists only on the three product pages (the section renders nothing, and so loads nothing, anywhere else).
 * Writes nothing except the cart line the customer asks for. Reads only product data.
 */
(function () {
  'use strict';
  if (window.__bsPiece) return;
  window.__bsPiece = true;

  var doc = document, html = doc.documentElement;
  var reduced = false; try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var REFRESH_MS = 20000;

  var el = null, ui = {};
  var S = { open: false, handle: '', productId: '', name: '', price: '', variants: {}, sel: 0, busy: false, ready: false, applied: 0, timer: 0, opener: null, optionName: 'Piece Number', total: 55 };
  var seq = 0;   // numbers every availability request, so a slow, old answer can never overwrite a newer one

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function T(k) { return (el && el.getAttribute('data-t-' + k)) || ''; }
  function $(s) { return el.querySelector(s); }

  /* ── mount: the sheet lives on <body> so no transformed ancestor can ever clip it ───────────── */
  function mount() {
    var found = [].slice.call(doc.querySelectorAll('[data-bs-drawer]'));
    if (!found.length) return;
    var fresh = found.filter(function (n) { return n.parentNode !== doc.body; })[0];
    if (!fresh) { if (!el) bind(found[0]); return; }
    found.forEach(function (n) { if (n !== fresh && n.parentNode === doc.body) n.parentNode.removeChild(n); });
    if (S.open) close(true);
    doc.body.appendChild(fresh);
    bind(fresh);
  }

  function bind(node) {
    el = node;
    ui = { backdrop: $('[data-bs-dr-backdrop]'), sheet: $('[data-bs-dr-sheet]'), close: $('[data-bs-dr-close]'), grid: $('[data-bs-dr-grid]'), msg: $('[data-bs-dr-msg]'), go: $('[data-bs-dr-go]'), golabel: $('[data-bs-dr-golabel]'), live: $('[data-bs-dr-live]') };
    S.handle = el.getAttribute('data-handle'); S.productId = el.getAttribute('data-product-id');
    S.name = el.getAttribute('data-name'); S.price = el.getAttribute('data-price');
    S.optionName = el.getAttribute('data-option') || 'Piece Number';
    S.total = parseInt(el.getAttribute('data-total'), 10) || 55;
    if (el.__bsBound) return;
    el.__bsBound = true;
    ui.close.addEventListener('click', function () { close(); });
    var down = false;
    ui.backdrop.addEventListener('pointerdown', function () { down = true; });
    ui.backdrop.addEventListener('click', function () { if (down) close(); down = false; });
    ui.sheet.addEventListener('pointerdown', function () { down = false; });
    ui.go.addEventListener('click', confirmChoice);
    ui.grid.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-n]');
      if (!b || b.disabled) return;
      choose(parseInt(b.getAttribute('data-n'), 10));
    });
    ui.grid.addEventListener('keydown', gridKeys);
    el.addEventListener('keydown', trap);
  }

  /* In Shopify's draft preview a bar is pinned to the bottom of the screen (above everything). The sheet sits above it. */
  function barOffset() {
    var f = doc.getElementById('PBarNextFrameWrapper'), h = 0;
    if (f) { var r = f.getBoundingClientRect(); if (r.height > 0 && r.bottom >= (window.innerHeight || 0) - 2) h = Math.ceil(r.height); }
    el.style.setProperty('--bs-pbar', h + 'px');
  }
  window.addEventListener('resize', function () { if (el && S.open) barOffset(); });

  /* ── open / close ─────────────────────────────────────────────────────────────────────────── */
  /* ONE place that returns the PRE-ORDER button to its resting state whenever the sheet closes (X, backdrop, Escape, a section reload, or after an add):
     label back if anything cleared it, enabled, no leftover loading state. The label's colour on focus is handled in spirit-pdp.css. */
  var BTN = { node: null, html: '' };
  function rememberBtn(b) { if (b && b !== BTN.node && b.innerHTML.trim()) { BTN.node = b; BTN.html = b.innerHTML; } }
  function resetBtn() {
    var b = BTN.node; if (!b || !b.isConnected) return;
    if (!(b.innerText || '').trim() && BTN.html) b.innerHTML = BTN.html;
    b.disabled = false; b.removeAttribute('aria-disabled');
    [].slice.call(b.classList).forEach(function (c) { if (/loading/i.test(c)) b.classList.remove(c); });
  }

  function open(opener) {
    if (!el) mount();
    if (!el || S.open) return false;
    rememberBtn(opener);
    S.opener = opener || null; S.sel = 0; S.busy = false;
    buildGrid(); paintGrid(); setMsg(''); updateGo();
    el.hidden = false;
    barOffset();
    html.classList.add('bs-dr-open');
    void ui.sheet.offsetWidth;
    el.classList.add('is-open');
    S.open = true;
    setTimeout(function () { try { ui.sheet.focus({ preventScroll: true }); } catch (e) {} }, reduced ? 0 : 60);
    refresh();
    clearInterval(S.timer);
    S.timer = setInterval(function () { if (!doc.hidden && !S.busy) refresh(); }, REFRESH_MS);
    return true;
  }

  function close(skipFocus) {
    if (!S.open) return;
    S.open = false;
    clearInterval(S.timer);
    el.classList.remove('is-open');
    html.classList.remove('bs-dr-open');
    var done = function () { if (!S.open) el.hidden = true; };
    if (reduced) done(); else setTimeout(done, 520);
    S.sel = 0; resetBtn();
    if (!skipFocus && S.opener) { try { S.opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ── the grid ─────────────────────────────────────────────────────────────────────────────── */
  function buildGrid() {
    if (ui.grid.children.length === S.total) return;
    ui.grid.textContent = '';
    for (var n = 1; n <= S.total; n++) {
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'bs-dr__n'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      b.setAttribute('data-n', n); b.textContent = pad(n); b.tabIndex = -1;
      ui.grid.appendChild(b);
    }
  }
  function state(n) { var v = S.variants[n]; return !S.ready ? 'loading' : (v && v.available ? 'free' : 'sold'); }

  function paintGrid() {
    var firstFree = 0;
    [].forEach.call(ui.grid.children, function (b) {
      var n = parseInt(b.getAttribute('data-n'), 10), st = state(n), isSel = S.sel === n && st === 'free';
      b.classList.toggle('is-sold', st === 'sold'); b.classList.toggle('is-loading', st === 'loading'); b.classList.toggle('is-sel', isSel);
      b.disabled = st !== 'free';
      b.setAttribute('aria-disabled', st !== 'free' ? 'true' : 'false');
      b.setAttribute('aria-checked', isSel ? 'true' : 'false');
      b.setAttribute('aria-label', 'Piece ' + pad(n) + ' of ' + S.total + (st === 'sold' ? ', ' + (T('sold') || 'sold out') : ''));
      b.tabIndex = -1;
      if (st === 'free' && !firstFree) firstFree = n;
    });
    var tab = S.sel && state(S.sel) === 'free' ? S.sel : firstFree;
    if (tab) ui.grid.children[tab - 1].tabIndex = 0;
  }

  function choose(n) {
    if (state(n) !== 'free') return;
    S.sel = n; paintGrid(); updateGo(); setMsg('');
    ui.live.textContent = 'Piece ' + pad(n) + ' of ' + S.total + ' ' + (T('selected') || 'selected');
  }

  function updateGo() {
    var ok = S.sel && state(S.sel) === 'free' && !S.busy;
    ui.go.disabled = !ok; ui.go.setAttribute('aria-disabled', ok ? 'false' : 'true');
    ui.golabel.textContent = (T('confirm') || 'Pre-order') + (S.sel ? ' · ' + pad(S.sel) + '/' + S.total : '');
  }

  function setMsg(text, retry) {
    ui.msg.textContent = '';
    if (!text) return;
    ui.msg.appendChild(doc.createTextNode(text));
    if (retry) {
      var r = doc.createElement('button'); r.type = 'button'; r.className = 'bs-dr__retry'; r.textContent = T('retry') || 'Try again';
      r.addEventListener('click', function () { refresh(); });
      ui.msg.appendChild(doc.createTextNode(' ')); ui.msg.appendChild(r);
    }
  }

  function gridKeys(e) {
    var k = e.key, cur = e.target.closest('button[data-n]');
    if (!cur) return;
    var cols = getComputedStyle(ui.grid).gridTemplateColumns.split(' ').length || 1;
    var n = parseInt(cur.getAttribute('data-n'), 10), step = 0;
    if (k === 'ArrowRight') step = 1; else if (k === 'ArrowLeft') step = -1; else if (k === 'ArrowDown') step = cols; else if (k === 'ArrowUp') step = -cols;
    else if (k === 'Home') { n = 0; step = 1; } else if (k === 'End') { n = S.total + 1; step = -1; } else return;
    e.preventDefault();
    var m = n + step;
    while (m >= 1 && m <= S.total && state(m) !== 'free') m += (k === 'ArrowDown' || k === 'ArrowUp') ? step : (step > 0 ? 1 : -1);
    if (m >= 1 && m <= S.total) { [].forEach.call(ui.grid.children, function (b) { b.tabIndex = -1; }); var t = ui.grid.children[m - 1]; t.tabIndex = 0; t.focus(); }
  }

  /* ── availability: the product's real variants ────────────────────────────────────────────── */
  function load() {
    var my = ++seq;
    return fetch(root + 'products/' + encodeURIComponent(S.handle) + '.js?_=' + Date.now(), { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (p) {
        var names = (p.options || []).map(function (o) { return (o && o.name) || o; });
        var idx = names.indexOf(S.optionName);
        if (idx < 0) throw new Error('no option');
        var map = {};
        (p.variants || []).forEach(function (v) {
          var m = /^\s*(\d{1,3})\s*\/\s*\d+\s*$/.exec(v['option' + (idx + 1)] || '');
          if (m) map[parseInt(m[1], 10)] = { id: v.id, available: !!v.available };
        });
        if (my > S.applied) { S.applied = my; S.variants = map; S.ready = true; }   // newest answer wins; an older one never cancels a caller
        return map;
      });
  }

  function refresh() {
    if (!S.ready) setMsg(T('loading'));
    return load().then(function () {
      if (!S.open) return;
      if (S.sel && state(S.sel) !== 'free') { S.sel = 0; setMsg(T('reserved')); ui.live.textContent = T('reserved'); }
      else if (!S.busy) setMsg('');
      var free = 0; for (var n = 1; n <= S.total; n++) if (state(n) === 'free') free++;
      if (!free) setMsg(T('soldout'));
      paintGrid(); updateGo();
    }).catch(function () {
      if (!S.open) return;
      if (S.ready) return;   /* a missed background look keeps the last known state; the look before the add checks again */
      paintGrid(); updateGo(); setMsg(T('error'), true);
    });
  }

  /* ── the add: the exact variant, after one last look at availability ──────────────────────── */
  function confirmChoice() {
    if (!S.sel || S.busy) return;
    var n = S.sel;
    S.busy = true; updateGo(); setMsg(T('adding'));
    load().then(function () {
      var v = S.variants[n];
      if (!v || !v.available) { S.busy = false; S.sel = 0; paintGrid(); updateGo(); setMsg(T('reserved')); ui.live.textContent = T('reserved'); return; }
      return add(v.id).then(function (res) {
        if (res.ok) { S.busy = false; done(res.json); return; }
        // refused: Shopify's inventory has spoken. Look again to tell "just reserved" from "already in this bag".
        return load().then(function () {
          S.busy = false;
          var still = S.variants[n] && S.variants[n].available;
          if (still) setMsg(T('inbag')); else { S.sel = 0; setMsg(T('reserved')); ui.live.textContent = T('reserved'); }
          paintGrid(); updateGo();
        });
      });
    }).catch(function () { S.busy = false; paintGrid(); updateGo(); setMsg(T('error'), true); });
  }

  function add(id) {
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    if (doc.querySelector('m-cart-drawer')) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
    return fetch((window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) || (root + 'cart/add'), {
      method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !j.status, json: j }; }); });
  }

  /* the piece is in the bag: hand over to the theme's own bag drawer, so the line reads "<edition> / Piece Number: 15/55" */
  function done(json) {
    close(true);
    try {
      var cart = doc.querySelector('m-cart-drawer'), S2 = window.MinimogSettings;
      if (cart && cart.renderContents && S2 && S2.enable_cart_drawer && json && json.sections) {
        cart.renderContents(json);
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
        fetch(root + 'cart.json', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (cart.updateCartCount) cart.updateCartCount(c.item_count); });
        return;
      }
    } catch (e) { /* fall through to the bag page */ }
    window.location.href = root + 'cart';
  }

  /* ── focus trap, Escape ───────────────────────────────────────────────────────────────────── */
  function trap(e) {
    if (e.key !== 'Tab' || !S.open) return;
    var list = [].filter.call(el.querySelectorAll('button, [href], [tabindex]'), function (n) { return !n.disabled && n.tabIndex >= 0 && n.offsetParent !== null; });
    if (!list.length) { e.preventDefault(); ui.sheet.focus(); return; }
    var first = list[0], last = list[list.length - 1], a = doc.activeElement;
    if (e.shiftKey && (a === first || a === ui.sheet)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) { e.preventDefault(); close(); } });
  doc.addEventListener('visibilitychange', function () { if (!doc.hidden && S.open && !S.busy) refresh(); });

  /* ── the interception: ADD TO BAG on THIS product's form opens the selector instead of adding ─ */
  function isThisProductForm(form) {
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return false;
    var id = form.getAttribute('data-product-id') || (form.querySelector('[name="product-id"]') || {}).value || '';
    return !!S.productId && String(id) === String(S.productId);
  }
  function intercept(e, form, opener) {
    if (!el) mount();
    if (!el) return;                                  // no selector on this page: never block the normal flow
    e.preventDefault(); e.stopImmediatePropagation();
    open(opener || form.querySelector('button[type="submit"], .m-add-to-cart'));
  }
  doc.addEventListener('submit', function (e) { var f = e.target; if (isThisProductForm(f)) intercept(e, f); }, true);
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type="submit"], .m-add-to-cart, [name="add"]');
    if (!b) return;
    var f = b.closest('form');
    if (isThisProductForm(f)) intercept(e, f, b);
  }, true);

  doc.addEventListener('shopify:section:load', function () { mount(); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount); else mount();
})();
